<template>
    <path d="M6.68125 16.6667L17.2458 6.10209L15.7729 4.62917L5.20833 15.1938V16.6667H6.68125ZM7.54479 18.75H3.125V14.3302L15.0365 2.41876C15.2318 2.22347 15.4967 2.11377 15.7729 2.11377C16.0491 2.11377 16.314 2.22347 16.5094 2.41876L19.4562 5.36563C19.6515 5.56097 19.7612 5.82588 19.7612 6.10209C19.7612 6.3783 19.6515 6.64321 19.4562 6.83855L7.54479 18.75ZM3.125 20.8333H21.875V22.9167H3.125V20.8333Z"
          fill="#00AF41"></path>
</template>

<script>
    export default {
        name: 'icon-pencil'
    }
</script>